// extracted by mini-css-extract-plugin
module.exports = {"title":"pureflo_title__3VwS6","wrapper":"pureflo_wrapper__20PqQ","grey":"pureflo_grey__2xJcB","white":"pureflo_white__9LPy9"};